export class TripsFiltersPath {
  public static readonly SERVICE = 'serviceAvailability.service.serviceInfo.id';
  public static readonly DRIVER = 'driver.id';
  public static readonly VEHICLE = 'vehicle.id';
  public static readonly INITIAL_STOP = 'expeditionStop.id';
  public static readonly DATE_TIME = '';
  public static readonly STATUS = 'status';
  public static readonly TYPE = 'expeditionType';
}
